export default {
  methods: {
    validateEmail(email) {
      let re = /^\S+@\S+$/;
      return re.test(String(email).toLowerCase());
    }
  }
};
